import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default EvalRunConfigPersonaTable;

function EvalRunConfigPersonaTable(props) {
  const { personas, onEditPersona, onDeletePersona } = props;

  if (personas.length === 0) return null;

  return (
    <Table>
      <TableHead>
        <TableHeader>Name</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {personas.map((persona, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{persona.name}</TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={() => onEditPersona(persona, idx)}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={() => onDeletePersona(idx)}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
